/**
 * This is actions-detail script.js file
 */
import permissionUser from '@/inheritance/permission-user';

export default {
    name       : 'ActionsDetail',

    extends: permissionUser,

    props : {
        icon : {
            type     : String,
            required : false
        },
        title : {
            type     : String,
            required : true
        },
        linkDelete : {
            type     : Boolean
        },
        textDelete : {
            type     : String,
            required : false,
            default  : 'Eliminar'
        },
        editable : {
            type     : Boolean
        },
        permission : {
            type     : String,
            required : true
        },
        actionDelete : {
            type     : Function,
            required : false
        }
    }
};
